import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "title", "panel", "container", "background" ]

  #boundHide = null
  #hideTimeout = null
  #showTimeout = null

  connect() {
    // Ensure the panel starts fully off-screen without scheduling a delayed
    // hide (see #hide) — the container/background already render with the
    // "hidden" class from the server, so there is nothing to defer here.
    this.panelTarget.classList.add("translate-x-full")
    this.#boundHide = this.hide.bind(this)
    window.addEventListener("drawer:hide", this.#boundHide)
  }

  disconnect() {
    window.removeEventListener("drawer:hide", this.#boundHide)
    clearTimeout(this.#hideTimeout)
    clearTimeout(this.#showTimeout)
  }

  show(event) {
    clearTimeout(this.#hideTimeout)
    clearTimeout(this.#showTimeout)
    this.titleTarget.innerHTML = event.currentTarget.dataset.title
    this.backgroundTarget.classList.remove("hidden")
    this.containerTarget.classList.remove("hidden")
    this.#showTimeout = setTimeout(() => {
      this.panelTarget.classList.remove("translate-x-full")
      this.panelTarget.classList.add("translate-x-0")
    }, 10)
  }

  closeOnBackground(event) {
    if (!this.panelTarget.contains(event.target)) {
      this.hide();
    }
  }

  hideOnSuccess(event) {
    if (event.detail.success) {
      this.hide();
    }
  }

  hide() {
    clearTimeout(this.#showTimeout)
    this.panelTarget.classList.remove("translate-x-0")
    this.panelTarget.classList.add("translate-x-full")
    // Cancel any previously scheduled hide so a rapid hide -> show -> hide
    // sequence can't leave a stale timeout that yanks the drawer closed
    // out from under a subsequent #show call.
    clearTimeout(this.#hideTimeout)
    this.#hideTimeout = setTimeout(() => {
      this.containerTarget.classList.add("hidden")
      this.backgroundTarget.classList.add("hidden")
    }, 500)
  }
}
